export var VerboseLevel;
(function (VerboseLevel) {
    VerboseLevel["Log"] = "Log";
    VerboseLevel["Info"] = "Info";
    VerboseLevel["Warn"] = "Warn";
    VerboseLevel["Error"] = "Error";
    VerboseLevel["None"] = "None";
})(VerboseLevel || (VerboseLevel = {}));
export class Logger {
    constructor(verboseLevel = VerboseLevel.None) {
        this.levels = [VerboseLevel.Log, VerboseLevel.Info, VerboseLevel.Warn, VerboseLevel.Error, VerboseLevel.None];
        if (this.levels.indexOf(verboseLevel) === -1) {
            throw new Error(`Verbose level ${verboseLevel} not supported`);
        }
        this.verboseLevel = verboseLevel;
    }
    hasVerboseLevel(level) {
        const currentVerboseValue = this.levels.indexOf(level);
        const configuredVerboseValue = this.levels.indexOf(this.verboseLevel);
        return currentVerboseValue - configuredVerboseValue >= 0;
    }
    assert(...args) {
        console.assert(...args);
    }
    clear() {
        console.clear();
    }
    count(...args) {
        console.count(...args);
    }
    countReset(...args) {
        console.countReset(...args);
    }
    debug(...args) {
        if (this.hasVerboseLevel(VerboseLevel.Log)) {
            console.debug(...args);
        }
    }
    dir(...args) {
        console.dir(...args);
    }
    dirxml(...args) {
        console.dirxml(...args);
    }
    error(...args) {
        if (this.hasVerboseLevel(VerboseLevel.Error)) {
            console.error(...args);
        }
    }
    group(...args) {
        console.group(...args);
    }
    groupCollapsed(...args) {
        console.groupCollapsed(...args);
    }
    groupEnd() {
        console.groupEnd();
    }
    info(...args) {
        if (this.hasVerboseLevel(VerboseLevel.Info)) {
            console.info(...args);
        }
    }
    log(...args) {
        if (this.hasVerboseLevel(VerboseLevel.Log)) {
            console.log(...args);
        }
    }
    profile(...args) {
        console.profile(...args);
    }
    profileEnd(...args) {
        console.profileEnd(...args);
    }
    table(...args) {
        console.table(...args);
    }
    time(...args) {
        console.time(...args);
    }
    timeEnd(...args) {
        console.timeEnd(...args);
    }
    timeLog(...args) {
        console.timeLog(...args);
    }
    timeStamp(...args) {
        console.timeStamp(...args);
    }
    trace(...args) {
        if (this.hasVerboseLevel(VerboseLevel.Log)) {
            console.trace(...args);
        }
    }
    warn(...args) {
        if (this.hasVerboseLevel(VerboseLevel.Warn)) {
            console.warn(...args);
        }
    }
}
